import React, { useEffect, useMemo } from 'react'
import { RouteProps, useParams, Navigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { actions, selectors } from '../../redux'
import { Screen } from '../../types/global'
import { useTracking } from '../../tracking/index'

import RegisterPage from './Register'
import SuccessPage from './Success'
import ConfirmationPage from './Confirmation'
import ClosedPage from './Closed'
import LoaderPage from './LoaderPage'
import UnavailablePage from './Unavailable'

const RootPage: React.FC<RouteProps> = () => {
  const dispatch = useDispatch()
  const params = useParams<{ slug: string }>()
  // SELECTORS

  useTracking()

  const screen = useSelector(selectors.app.screen)
  const getEventBySlug = useSelector(selectors.app.getEventBySlug)
  const getLabels = useSelector(selectors.app.getLabels)

  const isEventClosed = useMemo(() => {
    if (getEventBySlug.data?.registration_closing_at) {
      const todayDate = new Date()
      const closingDate = new Date(getEventBySlug.data?.registration_closing_at?.replace(/-/g, '/'))
      return todayDate?.getTime() > closingDate?.getTime()
    }

    return false
  }, [getEventBySlug.data?.registration_closing_at])

  // EFFECT

  useEffect(() => {
    dispatch(
      actions.app.getEventBySlugRequest({
        slug: params.slug!,
      })
    )
  }, [dispatch, params.slug])

  // RETURN

  if (screen === Screen.success) {
    return <SuccessPage />
  }

  if (getEventBySlug.pending) {
    return <LoaderPage />
  }

  if (!getEventBySlug.data || !getLabels.data) {
    return <UnavailablePage />
  }

  if (!getEventBySlug.data?.uuid) {
    return <Navigate to={'/'} />
  }

  if (isEventClosed) {
    return <ClosedPage />
  }

  return (
    <>
      {screen === Screen.register && <RegisterPage />}
      {screen === Screen.confirmation && <ConfirmationPage />}
    </>
  )
}

export default RootPage
